export default [
  {
    value: '',
    label: 'Combined',
    columnName: 'Unique_Market_Reference_UMR',
  },
  {
    lineBreak: true
  },
  {
    value: 'underwriter',
    label: 'Underwriter',
    columnName: 'Underwriter',
    altColumnName: 'Unique_Market_Reference_UMR',
    isIndependent: true
  },
  {
    value: 'coverholder',
    label: 'Coverholder',
    columnName: 'Coverholder_Name',
    altColumnName: 'Unique_Market_Reference_UMR'
  },
  {
    value: 'tpa',
    label: 'TPA',
    columnName: 'TPA_Name',
    altColumnName: 'Unique_Market_Reference_UMR'
  },
  {
    lineBreak: true
  },
  {
    value: 'umr',
    label: 'UMR',
    columnName: 'Unique_Market_Reference_UMR',
    isDefault: true
  },
  {
    value: 'lloyds_cat_code',
    label: 'Cat Code',
    columnName: 'Lloyds_Cat_Code',
    altColumnName: 'Unique_Market_Reference_UMR',
    isDefault: true
  },
  {
    value: 'section_no',
    label: 'Section No',
    columnName: 'Section_No',
    altColumnName: 'Unique_Market_Reference_UMR',
    isDefault: true
  },
  {
    lineBreak: true
  },
  {
    value: 'umr-risk_code',
    label: 'UMR/Risk Code',
    columnName: 'Unique_Market_Reference_UMR-Risk_Code'
  },
  {
    value: 'umr-lloyds_cat_code',
    label: 'UMR/Cat Code',
    columnName: 'Unique_Market_Reference_UMR-Lloyds_Cat_Code'
  },
  {
    value: 'umr-risk_code-lloyds_cat_code',
    label: 'UMR/Risk Code/Cat Code',
    columnName: 'Unique_Market_Reference_UMR-Risk_Code-Lloyds_Cat_Code'
  },
  {
    value: 'umr-risk_code-lloyds_cat_code-section_no',
    label: 'UMR/Risk Code/Cat Code/Section No',
    columnName: 'Unique_Market_Reference_UMR-Risk_Code-Lloyds_Cat_Code-Section_No'
  },  
  {
    lineBreak: true
  },
  {
    value: 'umr-risk_code-lloyds_cat_code-section_no-settlement_currency-year_of_account',
    label: 'UMR/Risk Code/Cat Code/Section No/Settlement Currency/Year of Account',
    columnName:
      'Unique_Market_Reference_UMR-Risk_Code-Lloyds_Cat_Code-Section_No-Settlement_Currency-Year_of_Account'
  }
]
